import React from "react";
import { MainContext } from "../main-context.js";
import Admin from "./Home/Admin.js";
import Fueler from "./Home/Fueler.js";
import Maintainer from "./Home/Maintainer.js";

export default function Home() {
  return (
    <MainContext.Consumer>
      {({ status, constants }) => (
        <div className="layout-admin">
          <div className="admin-content" id="admin-content">
            <div className="container">
              <div className="row row-admin-content">
                <div className="col-xs-12 mobile-content-wrap">
                  {(status.group.name === constants.FUELERS && <Fueler />) ||
                    (status.group.name === constants.MAINTAINERS && (
                      <Maintainer />
                    )) ||
                    (status.group.name === constants.ADMINS && <Admin />) || (
                      <div>NOT KNOWN</div>
                    )}
                </div>
              </div>
            </div>
            <div className="container-fluid">
              <div className="row row-admin-content"></div>
            </div>
          </div>
        </div>
      )}
    </MainContext.Consumer>
  );
}
